// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"toggle_checkbox__EHaUe","label":"toggle_label__Wy9Dg"};